export const codeOrderBillRouter = [
  {
    path: '/codeOrderBill',
    name: 'codeOrderBill',
    component: () => import('@/views/codeOrderBill/index'),
    meta: {
      title: '账单',
      keepAlive: true
    }
  },
  {
    path: '/codeOrderBill/selectStore',
    name: 'codeOrderBillSelectStore',
    component: () => import('@/views/codeOrderBill/selectStore'),
    meta: {
      title: '选择门店'
    }
  }
]
